import { MyPageUserImagePostInputModel } from "./PostInputModel"
import { httpFormPost } from "../../../../../libs/http/httpFormPost"

const endpointUrl = "/v1/mypage/user/image"

export const postMyPageUserImage = async (
  model: MyPageUserImagePostInputModel,
) => {
  return httpFormPost<void>(endpointUrl, model)
}
